import React, { useEffect, useState } from 'react';
import './Header.css';
import Button from '../common/Button';
import { auth } from '../../services/api';
import { API_BASE_URL } from '../../config/api';

const Header: React.FC = () => {
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const token = auth.getToken();
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const name = payload.name || payload.given_name || '';
        setUserEmail(name || payload.email || payload['cognito:username'] || '');
      } catch {
        setUserEmail('');
      }
    }
  }, []);

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    try {
      await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...auth.getAuthHeaders()
        },
        body: JSON.stringify({ refresh_token: refreshToken })
      });
    } catch {}
    auth.clearToken();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/signed-out';
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <img
            src="/joule-logo.png"
            alt="Joule"
            className="header-logo"
          />
        </div>
        <div className="header-center">
          <h1 className="header-title">Staff Portal</h1>
          <span className="header-subtitle">Utility Invoice Processing System</span>
        </div>
        <div className="header-right">
          <div className="header-user">
            <span className="header-user-name">{userEmail}</span>
          </div>
          <Button variant="secondary" size="small" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
